import { useState } from "react";
import { Link } from "react-router-dom";

import {
  CODE_HOME_PATH,
  COLOR_CONVERT_POST,
  HELLO_ISSUES_POST,
  HELLO_WORLD_POST,
  MY_FIRST_REAL_VIBE_POST,
} from "../../../routes/paths";
import {
  CategoryFilter,
  EmptyContentState,
  PageWrapper,
} from "../../../shared-components";
import { PostPreviewTile } from "../../../shared-components/tiles";

import "./PostsHome.scss";

export enum PostCategory {
  CoolThing = "cool_thing",
  HowTo = "how_to",
  TheArt = "the_art",
  TheJob = "the_job",
  VibeCoding = "vibe_coding",
}

export function PostCategoryDisplayName(category: PostCategory) {
  return category.replaceAll("_", " ");
}

const postCategories = Object.values(PostCategory);

const posts = [
  {
    category: PostCategory.VibeCoding,
    route: COLOR_CONVERT_POST,
    teaser:
      "A color converter session that moved from first pass to mockup polish to tiny UX corrections.",
    title: "Color Convert",
  },
  {
    category: PostCategory.VibeCoding,
    route: MY_FIRST_REAL_VIBE_POST,
    teaser:
      "A look at the first session that felt less like prompting and more like collaborating.",
    title: "My first real vibe",
  },
  {
    category: PostCategory.HowTo,
    route: HELLO_ISSUES_POST,
    teaser:
      "A lightweight workflow from issue label to local branch to verified change.",
    title: "Hello issues!",
  },
  {
    category: PostCategory.CoolThing,
    route: HELLO_WORLD_POST,
    teaser: "In a world, where teasers have a voice, we have some writing.",
    title: "Hello World",
  },
];

function PostsHomeScreen() {
  const [selectedCategory, setSelectedCategory] = useState<PostCategory | null>(
    null,
  );
  const filteredPosts = selectedCategory
    ? posts.filter((post) => post.category === selectedCategory)
    : posts;
  const latestPost = filteredPosts[0];
  const remainingPosts = latestPost
    ? filteredPosts.filter((post) => post.route !== latestPost.route)
    : filteredPosts;

  return (
    <PageWrapper>
      <main className="posts-screen">
        <p>
          👈 <Link to={CODE_HOME_PATH}>Back to code</Link>
        </p>
        <h1>When you write enough code you want to write something else</h1>
        <div className="subheader">(...but, you know, still about code)</div>
        <h2>Categories</h2>
        <CategoryFilter
          categories={postCategories}
          categoryClassName="postCategoryLabel"
          displayName={PostCategoryDisplayName}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <h2>Latest Post</h2>
        {/* NEW_POST: like a T0D0 comment for myself so I remember where I do the manual things */}
        {latestPost ? (
          <PostPreviewTile
            category={latestPost.category}
            route={latestPost.route}
            teaser={latestPost.teaser}
            title={latestPost.title}
          />
        ) : (
          <EmptyContentState
            alt="A colorful empty coding stage with brackets, a terminal prompt, and an empty content panel."
            message="Nothing here yet."
          />
        )}
        <div className="posts">
          <h2>Other Posts</h2>
          {remainingPosts.map((post) => (
            <PostPreviewTile
              category={post.category}
              key={post.route}
              route={post.route}
              teaser={post.teaser}
              title={post.title}
            />
          ))}
        </div>
      </main>
    </PageWrapper>
  );
}

export default PostsHomeScreen;
